import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../core/rootHooks';
import { AppDispatch, RootState } from '../../core/store';
import VesselMsiValue from './containers/VesselMsiValue';
import FleetMsiValue from './containers/FleetMsiValue';
import SummaryMsiValue from './containers/SummaryMsiValue';
import { getVesselMsiValueRequestAction, getVesselRecentSalesRequestAction, getSummaryMsiValueRequestAction } from './valueSlice';
import { EOutputType } from '../../shared/sharedEnums';
import { selectSelectionData } from '../search/searchSelectors';
import { selectMsiValueData, valueVesselListSelector } from './valueSelector';
import Logo from '../../shared/components/dashboard/Logo';
import ValueLogoSrc from '../../assets/images/logos/logo_value.svg';
import LoadingSpinner from '../../shared/components/loading-spinner/LoadingSpinner';
import Coverage from '../../shared/components/dashboard/Coverage';
import { selectIsMsi } from '../../user-management/appSelectors';

const Values: React.FC = () => {
	const { outputType } = useAppSelector(selectSelectionData);
	const { vesselListMsiValue } = useAppSelector((state: RootState) => state.valueSlice);
	const { vesselListRecentSales } = useAppSelector((state: RootState) => state.valueSlice);
	const { summaryMsiValue } = useAppSelector((state: RootState) => state.valueSlice);
	const msiValueData = useAppSelector(selectMsiValueData);

	const valueVesselList = useAppSelector(valueVesselListSelector);
	const isMsi = useAppSelector(selectIsMsi);

	const dispatch = useAppDispatch<AppDispatch>();

	useEffect(() => {
		if (valueVesselList.length > 0) {
			const imoList = valueVesselList.map((v) => v.imoNumber);

			if (outputType === EOutputType.Vessel || outputType === EOutputType.Fleet) {
				dispatch(getVesselMsiValueRequestAction(imoList));
				dispatch(getVesselRecentSalesRequestAction(imoList));
			} else if (outputType === EOutputType.Summary) {
				dispatch(getSummaryMsiValueRequestAction(imoList));
			}
		}
	}, [dispatch, valueVesselList, outputType]);

	return (
		<>
			<Logo src={ValueLogoSrc} />
			{vesselListMsiValue?.loading ? (
				<LoadingSpinner size="md" spinnerClassName="p-2" />
			) : outputType === EOutputType.Vessel ? (
				<VesselMsiValue
					vesselMsiValue={vesselListMsiValue?.dataList?.length === 1 ? vesselListMsiValue.dataList[0] : null}
					vesselRecentSales={
						vesselListRecentSales?.dataList?.length === 1 ? (vesselListRecentSales.dataList[0].vesselRecentSales ?? []) : []
					}
					data={valueVesselList[0]}
				/>
			) : outputType === EOutputType.Fleet ? (
				<FleetMsiValue
					vesselListMsiValue={vesselListMsiValue}
					vesselListRecentSales={vesselListRecentSales}
					selectedVessels={valueVesselList}
				/>
			) : outputType === EOutputType.Summary ? (
				<SummaryMsiValue summaryMsiValue={summaryMsiValue} />
			) : null}

			{isMsi && (
				<Coverage
					vesselsCount={msiValueData?.msiValueData?.imoCount}
					calculatedVesselsCount={msiValueData?.msiValueData?.calculatedImoCount}
					coveragePercentage={msiValueData?.msiValueData?.coveragePercentage}
				/>
			)}
		</>
	);
};

export default Values;
